import { create } from 'zustand';
import { packageAPI } from '../services/api';
import { Package, PromotionDetails } from '@shared/types';

interface PackageStoreState {
  packages: Package[];
  promotionDetails: PromotionDetails | null;
  isLoading: boolean;
  fetchPackages: () => Promise<void>;
  loadPackages: () => Promise<void>;
}

export const usePackageStore = create<PackageStoreState>((set, get) => ({
  packages: [],
  promotionDetails: null,
  isLoading: false,
  fetchPackages: async () => {
    const { packages, isLoading } = get();

    // Prevent concurrent fetches or refetching if data exists
    if (isLoading || packages.length > 0) {
      return;
    }

    set({ isLoading: true });

    try {
      const response = await packageAPI.getAll();
      const packages = Array.isArray(response.data) ? response.data : [];
      const promotionDetails = packages[0]?.promotionDetails || null;
      set({ packages, promotionDetails, isLoading: false });
    } catch (error) {
      console.error('Failed to fetch packages:', error);
      set({ isLoading: false });
    }
  },
  loadPackages: async () => {
    await get().fetchPackages();
  },
}));
